import { Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { If } from "lib/@components/if"

export function LegislationScheduleRow({ item }) {
    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={1.5}
            sx={{ py: 1, px: 1.5, borderBottom: "1px dashed", borderColor: "divider" }}
            data-cy="legislation-detail-schedule-row"
        >
            <Iconify
                icon="mdi:file-document-outline"
                sx={{ width: 20, height: 20, flexShrink: 0, color: "text.secondary" }}
            />
            <Stack sx={{ flex: 1, minWidth: 0 }}>
                <TruncatedTypography sx={{ fontSize: 14, fontWeight: 500 }}>{item?.title}</TruncatedTypography>
                <If truthy={item?.code}>
                    <Typography variant="caption" sx={{ color: "text.secondary" }}>
                        #{item?.code}
                    </Typography>
                </If>
            </Stack>
            <If truthy={item?.version}>
                <Typography variant="caption" sx={{ color: "text.disabled", flexShrink: 0, fontSize: 12 }}>
                    V{item?.version}
                </Typography>
            </If>
        </Stack>
    )
}
